<template>
  <div
    class="number_of_booster_picker b-radius-9"
    v-if="isDuoOptionSelected && packOptions.length > 0"
  >
    <div class="d-flex-row justify-start height-max-content gap-18">
      <HoodedBooster class="hooded_icon" />

      <div class="d-flex-column justify-start align-start gap-0">
        <div class="d-flex-row height-max-content space-between">
          <label class="t-white font-family-2 bold-xl">{{
            $t("extra_boosters")
          }}</label>
          <Tooltip :text="$t('extra_booster_help')" position="top">
            <PoiIcon />
          </Tooltip>
        </div>
        <p class="t-grey font-family-2 regular-m">
          {{ $t("select_extra_booster") }}
        </p>
      </div>
    </div>

    <ValueSetter v-model="extraBoosters" :min="1" :max="maxBoosters" />
  </div>
</template>

<script setup>
import HoodedBooster from "~/components/icons/packs/HoodedBooster.vue";
import ValueSetter from "../commonpickers/ValueSetter.vue";
import PoiIcon from "~/components/icons/PoiIcon.vue";
import Tooltip from "~/components/custom/Tooltip.vue";
const checkoutStore = useCheckoutStore();
const { getGame, getGamePack } = useGameStore();

const selfPlayOptions = computed(() => {
  const gamePackOptions =
    getGamePack.pack_options?.filter(
      (packOp) => packOp?.const_title === "self_play"
    ) || [];
  let parsedGameOptions = [];

  return gamePackOptions;
});

const packOptions = computed(() => {
  const gamePackOptions =
    getGamePack.pack_options?.filter((packOp) =>
      [
        "one_extra_boosters",
        "two_extra_boosters",
        "three_extra_boosters",
        "four_extra_boosters",
      ].includes(packOp?.const_title)
    ) || [];

  return gamePackOptions;
});

const isDuoOptionSelected = computed(() => {
  const option = selfPlayOptions.value[0];
  const selectedOption = checkoutStore.getPackOptions.find(
    (op) => op === option?.id
  );
  if (!selectedOption) {
    return false;
  }
  return true;
});
const maxBoosters = computed(() => {
  const gameSlug = checkoutStore.fullGame?.slug || "";
  if (gameSlug === "marvel-rivals-boost" || gameSlug === "ow-boost") {
    return 5;
  }
  if (
    gameSlug === "rainbow-six-siege-boost" ||
    gameSlug === "counter-strike-2-boost" ||
    gameSlug === "valorant-boost"
  ) {
    return 4;
  }
  if (gameSlug === "fortnite-boost") {
    return 3;
  }
  return 3;
});

const extraBoosters = ref(1);

const selectOption = (option) => {
  const otherBoosterOps = packOptions.value
    ?.filter((packOp) => packOp.id !== option?.id)
    .map((packOp) => packOp.id);
  checkoutStore.removePackOption({
    optionIds: [...otherBoosterOps] || [],
  });

  checkoutStore.setPackOptions({
    options: [...checkoutStore.getPackOptions, option.id],
  });
};

const purgeAll = () => {
  const otherBoosterOps = packOptions.value.map((packOp) => packOp.id);
  checkoutStore.removePackOption({
    optionIds: [...otherBoosterOps] || [],
  });
};

watch(extraBoosters, (newVal) => {
  const numberOfBoosters = newVal - 1;
  if (numberOfBoosters <= 0) {
    purgeAll();
    return;
  }
  const matchingOption = packOptions.value.find((packOp) =>
    packOp.title.includes(numberOfBoosters)
  );

  if (matchingOption?.id) {
    selectOption(matchingOption);
  }
});

watch(isDuoOptionSelected, (newVal) => {
  if (!newVal) {
    purgeAll();
    extraBoosters.value = 1;
  }
});
</script>

<style lang="scss">
.number_of_booster_picker {
  width: 100%;
  height: max-content;
  padding: 12px;
  background-color: var(--bg-dark);
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 9px;
  .hooded_icon {
    width: 57.4px;
    height: 57.4px;
  }
}
</style>
